import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {AnimationSettingsModel, ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import { FontModel } from '@syncfusion/ej2-progressbar';
import {ProgressDialogModel} from "./progress-dialog.model";
import {UtilService} from "../../services/util/util.service";

@Component({
  selector: 'sb-progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrls: ['./progress-dialog.component.scss']
})
export class ProgressDialogComponent implements OnInit, OnDestroy {

  @ViewChild('dialog') ejDialog: DialogComponent;

  public visible = false;

  public position: any = { X: 'center', Y: 'center' };

  public buttons: ButtonPropsModel[] = [
    {
      'click': this.hideDialog.bind(this),
      buttonModel: {
        content: 'Close',
      }
    },
    {
      'click': this.hideDialog.bind(this),
      buttonModel:{
        content: 'Continue',
        isPrimary: true,
      }
    },
  ];

  @Input()
  title: string = "";

  @Input()
  topic: string = "";

  @Input()
  autoClose: boolean = true;

  @Input()
  progressId: string = "default";

  public animationSettings: AnimationSettingsModel = {
    effect: 'None'
  };

  @Input()
  closeCallback = () => {};

  // There three inputs are so we can call methods on the angular component when
  // it is being used as a web component on the Knockout side.
  @Input()
  get ngShowDialog() {
    return this.showDialog();
  }

  @Input()
  get ngHideDialog() {
    return this.hideDialog();
  }

  @Input()
  get ngDestroyDialog() {
    return this.destroyDialog();
  }

  progressValue: number = 0;

  progressLabelStyle: FontModel = { color: 'white' };

  progressModels: ProgressDialogModel[] = [];

  private subscription: any;

  constructor(private cdr: ChangeDetectorRef, private utilService: UtilService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  public closeDialog(args: any) {
    if (this.closeCallback) {
      this.closeCallback();
    }
  }

  public async showDialog(model?: ProgressDialogModel) {
    this.ejDialog.show();

    this.subscribe();
    // Give the dialog a chance to settle down at the beginning.
    await this.utilService.sleep(100);
    this.updateProgress(model);
  }

  public hideDialog() {
    this.reset();
    this.unsubscribe();
    this.ejDialog.hide();
  }

  public destroyDialog() {
    this.unsubscribe();
    this.ejDialog.destroy();
  }

  public updateProgress(model: ProgressDialogModel) {
    if (model) {
      this.progressValue = model.percentage;

      // This is a dodgy way of setting a temporary progress message
      if (model.message.text.startsWith("::")) {
        model.temporary = true;
        model.message.text = model.message.text.substr(2);
        this.progressModels = this.progressModels.filter(it => !it.temporary);
        this.progressModels.push(model);
      } else {
        model.temporary = false;
        this.progressModels.push(model);
      }

      this.cdr.detectChanges();
    }
  }

  public subscribe() {
    if (!this.subscription) {
      this.subscription = (window as any).MessageBus.subscribe(
        (window as any).MessageBus.CHANNELS.MESSAGE_BUS_BRIDGE_API,
        this.topic,

        async (data: ProgressDialogModel) => {
          this.updateProgress(data);

          if (data.percentage && data.percentage >= 100) {
            // Give the dialog a chance to catch up at the end.
            await this.utilService.sleep(100);
            if (this.autoClose === true) {
              this.hideDialog();
            }
          }
        }
      );
    }
  }

  public unsubscribe() {
    this.subscription && (window as any).MessageBus.unsubscribe(this.subscription);
    this.subscription = null;
  }

  public reset() {
    this.progressValue = 0;
    this.progressModels = [];
    // TODO: if the dialog is hidden but the page remains visible because of an error we want to
    // still be able to redisplay the progress dialog.
    // this.topic = "";
    // this.title = "";
    this.autoClose = true;
    this.progressId = "default";
  }

}
